import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="relative hero-grad-dark text-white py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0 dots-dark opacity-50 pointer-events-none" />
      <div className="absolute -top-40 right-1/4 h-[500px] w-[500px] bg-emerald/12 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-[1280px] mx-auto px-5 md:px-8 relative">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/15 text-white font-mono text-[10.5px] uppercase tracking-[0.2em] font-bold mb-8">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald pulse-dot text-emerald" />
            Ready when you are
          </div>
          <h2 className="font-display font-extrabold text-[48px] sm:text-[72px] md:text-[96px] leading-[0.98] tracking-[-0.04em]">
            Get your tailored <br />
            <span className="text-emerald">funding offer today.</span>
          </h2>
          <p className="mt-8 text-[17px] md:text-[19px] leading-[1.55] text-white/75 max-w-xl mx-auto font-medium">
            Takes less than 3 minutes. No impact on the business credit file. Indicative APRs from 5.9%.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/apply"
              data-testid="cta-apply-btn"
              className="btn-shine group inline-flex items-center gap-2 h-14 px-8 rounded-xl bg-emerald text-white font-extrabold text-[15px] hover:bg-emerald-2 transition-colors shadow-emerald"
            >
              Get My Tailored Quote
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2.4} />
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[13px] text-white/70 font-semibold">
            <Tick>No credit footprint</Tick>
            <Tick>Whole-of-market panel</Tick>
            <Tick>3 minute application</Tick>
          </div>
        </div>
      </div>
    </section>
  );
}

function Tick({ children }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="h-4 w-4 rounded-full bg-emerald flex items-center justify-center">
        <Check className="h-2.5 w-2.5 text-white" strokeWidth={4} />
      </span>
      {children}
    </span>
  );
}
